import { useAtom } from 'jotai';

import AttributeTag from '@/tayara-kit/AttributeTag';
import Divider, { Orientation } from '@/tayara-kit/Divider';
import Text from '@/tayara-kit/Text';

import { ItemLayout, ItemSideGalleryLayout } from '../../store/grpc-free-store';
import { AdParam } from '../../types';

type AdParamsProps = {
  adParams: AdParam[];
};
const ItemAttributes = ({ adParams }: AdParamsProps) => {
  const [layout] = useAtom(ItemSideGalleryLayout);
  return (
    <>
      {adParams?.length === 0 ? (
        <></>
      ) : (
        <div>
          <Divider orientation={Orientation.HORIZONTAL} />
          <Text
            as="h2"
            text="Critères"
            className="text-gray-700 font-semibold text-xl mb-4"
          />

          {/* Key vertical button */}
          <ul className="grid gap-3 grid-cols-12">
            {adParams?.map((attr) => (
              <li
                key={attr.label}
                className={`col-span-6 ${
                  layout === ItemLayout.Normal ? 'lg:col-span-3' : ''
                }`}
              >
                {attr.label && attr.value && (
                  <AttributeTag label={attr.label} value={attr.value} />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default ItemAttributes;
